import request from '../../axios';

export const postSubBrandImage = async (payload: FormData) => {
  const response = await request.post(
    `/api/v2/store/create/sub-brand/image`,
    payload,
  );

  return response;
};
